import { Provider } from '@angular/core';

import { AuditUseCasesImpl } from '@app/domain/use-cases/audit/audit.use-cases';
import { AUDIT_USE_CASES } from '@app/domain/use-cases/audit/audit.use-cases.contract';

export const auditUseCasesProvider: Provider = {
  provide: AUDIT_USE_CASES,
  useClass: AuditUseCasesImpl
};
